export default __webpack_public_path__ + "static/media/warning-icon.452d5131.svg";